export const botPolicyPath = '/bot';
